import { useMemo } from 'react';

/**
 * Custom hook to calculate expiration status and styling
 * @param {string} expirationDate - ISO date string
 * @returns {Object} { expired, daysUntilExpiration, expirationColorClass, expirationText }
 */
export function useExpirationStatus(expirationDate) {
  return useMemo(() => {
    if (!expirationDate) {
      return {
        expired: false,
        daysUntilExpiration: null,
        expirationColorClass: '',
        expirationText: '',
        expirationTextClass: ''
      };
    }

    const expDate = new Date(expirationDate);
    const expDatePlusOne = new Date(expDate);
    expDatePlusOne.setDate(expDatePlusOne.getDate() );
    const currentDate = new Date();
    const diffTime = expDate - currentDate;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24) );
    
    const isExpired = expDatePlusOne < currentDate;
    
    // Determine color class
    let colorClass;
    let textClass;
    if (isExpired || diffDays <= 0) {
      colorClass = 'pill-button-expired'; // Red
      textClass = 'draft-expired';
    } else if (diffDays <= 3) {
      colorClass = 'pill-button-dark-orange'; // Dark Orange
      textClass = 'draft-critical';
    // } else if (diffDays <= 7) {
    //   colorClass = 'pill-button-light-orange'; // Light Orange
    //   textClass = 'draft-semi-critical';
    } else if (diffDays <= 10) {
      colorClass = 'pill-button-yellow'; // Yellow
      textClass = 'draft-warning';
    } else {
      colorClass = 'pill-button-good'; // Green
      textClass = 'draft-good';
    }

    // Generate expiration text
    let text;
    if (isExpired) {
      text = 'expired';
    } else if (diffDays === 0) {
      text = 'expires today';
    } else if (diffDays === 1) {
      text = 'expires tomorrow';
    } else {
      text = `${diffDays} days remaining`;
    }

    return {
      expired: isExpired,
      daysUntilExpiration: diffDays,
      expirationColorClass: colorClass,
      expirationText: text,
      expirationTextClass: textClass
    };
  }, [expirationDate]);
}
